import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AccountFoldersService } from '@modules/folders/folders.service';
import { TsComponent } from '../ts.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FileResource } from '@shared/modules/folders/folders.types';
import { map, Observable, tap } from 'rxjs';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TsButtonModule } from 'tsui';
import { TsDialogComponent } from 'tsui/lib/ts-dialog/ts-dialog.component';
import { TsSelectModule } from 'tsui/lib/ts-select/ts.select.module';
import { AsyncPipe } from '@angular/common';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { AccountState } from '@state/account/state';

@Component({
  selector: 'app-generate-merge-document',
  standalone: true,
  imports: [
    TsButtonModule,
    TsDialogComponent,
    TsSelectModule,
    ReactiveFormsModule,
    AsyncPipe,
    MatLegacyFormFieldModule,
    MatLegacyInputModule,
  ],
  templateUrl: './generate-merge-document.component.html',
  styleUrl: './generate-merge-document.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenerateMergeDocumentComponent extends TsComponent {
  fileResources$: Observable<FileResource[]>;
  canShowDocusignButton$ = this.store
    .select(AccountState.getAccount)
    .pipe(
      map(
        (account) =>
          account.subdomain === 'msc' || account.subdomain === 'urbanedge' || account.subdomain === 'urbanedgepoc',
      ),
    );
  form = new FormGroup({ file_id: new FormControl() });

  private accountFoldersService = inject(AccountFoldersService);
  private fileResources: FileResource[] = [];

  constructor(readonly matDialogRef: MatDialogRef<GenerateMergeDocumentComponent>) {
    super();
  }

  ngOnInit(): void {
    this.fileResources$ = this.accountFoldersService.getAllFiles(true).pipe(
      takeUntilDestroyed(this.destroyRef),
      map(
        (fileResources) =>
          fileResources?.filter(
            (option) =>
              option.name.toLowerCase().indexOf('.docx') > -1 ||
              option.name.toLowerCase().indexOf('.pdf') > -1 ||
              option.name.toLowerCase().indexOf('.pptx') > -1,
          ) ?? [],
      ),
      tap((fileResources) => (this.fileResources = fileResources)),
    );
  }

  save(mode: 'docusign' | 'save' = 'save'): void {
    const fileResourceId = this.form.get('file_id')?.value;
    const fileResource = this.fileResources.find((item) => item.id === Number(fileResourceId));

    this.matDialogRef.close({
      fileResourceId: fileResourceId,
      format: fileResource.name.includes('.pdf') ? 'pdf' : 'docx',
      sendToDocusign: mode === 'docusign',
    });
  }
}
